module.exports = __webpack_public_path__ + "static/media/artist.83e60785.png";